import { PopoverPosition as BlueprintPopoverPosition } from '@blueprintjs/core';
import classNames from 'classnames';
import * as React from 'react';

import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { useVoiceboxSettings } from 'bones/components/molecules/Voicebox/context/VoiceboxSettings';
import { Button } from 'bones/design-system/components/Button';
import { Tooltip } from 'bones/design-system/components/Tooltip';

export const VoiceboxDrawerButton: React.VFC = () => {
  const {
    copy,
    testIds,
    drawer: { isOpen, toggleIsOpen },
    settingsAside: { useSettings },
  } = useVoiceboxSchema();
  const { databasesById, databasesLoading, settings } = useVoiceboxSettings();

  const noDatabaseSelected = !useSettings && !settings.databaseId;
  const databaseIsNotEnabled =
    settings.databaseId && !databasesById[settings.databaseId];

  const disabled = Boolean(
    databasesLoading || noDatabaseSelected || databaseIsNotEnabled
  );

  return (
    <div
      className={classNames('vb-voicebox-drawer-button-container', {
        'vb-voicebox-drawer-button-container--open': isOpen,
      })}
    >
      <Tooltip
        description={
          noDatabaseSelected
            ? copy.voiceboxButton.noDatabase
            : copy.voiceboxButton.databaseDisabled
        }
        disabled={!disabled || databasesLoading}
        modifiers={{ offset: { options: { offset: [0, -50] } } }}
        position={BlueprintPopoverPosition.LEFT}
      >
        <Button
          className="vb-voicebox-drawer-button"
          disabled={disabled}
          onClick={() => {
            toggleIsOpen?.(!isOpen);
          }}
          size="md"
          testId={testIds.voiceboxButton}
          variant="primary-gray"
        >
          {copy.voiceboxButton.text}
        </Button>
      </Tooltip>
    </div>
  );
};
